import { render, staticRenderFns } from "./Purchased.vue?vue&type=template&id=2178a122&scoped=true&"
import script from "./Purchased.vue?vue&type=script&lang=js&"
export * from "./Purchased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178a122",
  null
  
)

export default component.exports